export const getSelectionStatus = editor => {
  const status = {
    isSelected: false,
    isGlossaryTerm: false,
    selectData: {
      text: '',
      glossaryTermId: ''
    }
  };
  const model = editor.model;
  const selection = model.document.selection;
  let selectedElement = selection.getSelectedElement();
  if (!selectedElement) {
    const selection = window.getSelection();
    if (!(!selection || selection.rangeCount === 0)) {
      const range = selection.getRangeAt(0);
      const selectedText = selection.toString();
      selectedElement = range.commonAncestorContainer.nodeType === Node.ELEMENT_NODE ? range.commonAncestorContainer : range.commonAncestorContainer.parentElement;
      if (selectedElement) {
        status.isSelected = true;
        status.selectData = {
          text: selectedText,
          id: selectedElement.getAttribute('data-glossary-term-id')
        };
        return status;
      }
    }
  }
  if (selectedElement && selectedElement.is('element', 'glossaryTerm')) {
    const text = selectedElement._children?._nodes?.[0]?._data || '';
    status.isSelected = true;
    status.isGlossaryTerm = true;
    status.selectData = {
      text: text,
      id: selectedElement.getAttribute('glossaryTermId')
    };
  } else {
    if (!selection.isCollapsed) {
      const range = selection.getFirstRange();
      const text = range ? Array.from(range.getItems()).map(item => item.is('textProxy') ? item.data : '').join('') : '';
      status.isSelected = !!text;
      status.selectData.text = text;
    }
  }
  return status;
};
const createElement = (writer, id, term) => {
  return writer.createElement('glossaryTerm', {
    glossaryTermId: id,
    glossaryTermTerm: term
  });
};
export const createLink = (editor, text, id, term = '', isGlossaryTerm = false, callback = () => {}) => {
  const {
    model
  } = editor;
  const {
    selection
  } = model.document;
  model.change(writer => {
    const element = createElement(writer, id, term);
    writer.wrap(selection.getFirstRange(), element);
  });
  if (typeof callback === 'function') callback();
};
export const editLink = (editor, id, term = '', callback = () => {}) => {
  const {
    model
  } = editor;
  const {
    selection
  } = model.document;
  const selectedElement = selection.getSelectedElement();
  model.change(writer => {
    const newId = id || selectedElement.getAttribute('glossaryTermId');
    const newTerm = term || selectedElement.getAttribute('glossaryTermTerm');
    writer.setAttribute('glossaryTermId', newId, selectedElement);
    writer.setAttribute('glossaryTermTerm', newTerm, selectedElement);
  });
  if (typeof callback === 'function') callback();
};
export const removeLInk = (editor, callback) => {
  const {
    model
  } = editor;
  const {
    selection
  } = model.document;
  const selectedElement = selection.getSelectedElement();
  if (selectedElement && selectedElement.is('element', 'glossaryTerm')) {
    model.change(writer => {
      writer.unwrap(selectedElement);
    });
    if (typeof callback === 'function') callback();
  }
};